"use strict";
exports.__esModule = true;
exports.PopinTheme = void 0;
var PopinTheme;
(function (PopinTheme) {
    PopinTheme["yellow"] = "yellow";
    PopinTheme["green"] = "green";
    PopinTheme["light_blue"] = "light-blue";
    PopinTheme["blue"] = "blue";
})(PopinTheme = exports.PopinTheme || (exports.PopinTheme = {}));
//# sourceMappingURL=popin.js.map